import { supabase } from '../services/supabaseService';

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const subscribeEmail = async (email) => {
  if (!email) {
    throw new Error('Please enter your email address');
  }

  if (!validateEmail(email)) {
    throw new Error('Please enter a valid email address');
  }

  try {
    // 检查邮箱是否已存在
    const { data: existingEmails } = await supabase
      .from('emails')
      .select('email_address')
      .eq('email_address', email)
      .single();

    if (existingEmails) {
      throw new Error('This email is already subscribed');
    }

    // 插入新邮箱
    const { error } = await supabase
      .from('emails')
      .insert([
        {
          email_address: email,
          created_at: new Date().toISOString()
        }
      ]);

    if (error) throw error;

    return { success: true };
  } catch (error) {
    throw new Error(error.message || 'Subscription failed');
  }
};
